import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { RestDataService } from '../../../service/rest-data.service';
import { Config } from '../../../config/config';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SharedDataService } from '../../../service/shared-data.service';

@Component({
  selector: 'app-brunch-element',
  templateUrl: './brunch-element.component.html',
  styleUrls: ['./brunch-element.component.css']
})
export class BrunchElementComponent implements OnInit {
  @Input() storyelementId: any;
  elementData:any;
  sampleImageIdList = [];
  sampleImageList = [];
  @ViewChild('embedEl', { static: false }) embedElement: ElementRef;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    autoWidth: true,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  }
  constructor(private restService: RestDataService, private config: Config,private sharedService: SharedDataService,) { }

  ngOnInit() {
    console.log("storyelementId",this.storyelementId)
     this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
      + '/'
      + String(this.storyelementId)
    )
      .subscribe(
        data => { 
          if(data){
            console.log("Data",data);
            this.elementData = data;
            if(this.elementData.type === 'sampleimages') {
              this.sampleImageIdList = this.elementData.sampleImagesIdList;
              this.getSampleImage();
            }
            if(this.elementData.type === 'listicleElement') {
               this.listicleEmbed();
            }
          } 
        })
  }

  listicleEmbed(){
    this.elementData.listicleArray.forEach(ele=>{
      if(ele.mediaType === 'embed') {
        this.sharedService.runEmbedProcessor(ele.media.embedCode, this.embedElement);
      }
    })
  }

  getSampleImage() {
    this.sampleImageIdList.forEach(ele=>{
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
        + '/'
        + String(ele)
      )
        .subscribe(
          data => { 
            if(data){
              console.log("SampleImage",data);
              this.sampleImageList.push(data);
            } 
          })
    })
  }

}
